<div class="d-flex align-items-center align-items-start pt-4"
     (click)="$event.stopPropagation();">
    <ng-container *ngIf="loadingCustomTags$ | async; else addTag">
        <button
            class="rounded-circle btn btn-primary btn-sm plus-icon"
        >
            <fa-icon [icon]="['far', 'spinner']" animation="spin-pulse" />
        </button>
    </ng-container>

    <ng-template #addTag>
        <button
            [pTooltip]="(tags?.length === 5 ? 'portal.tags.limit-reached' : 'portal.tags.add-tags-tooltip') | translate"
            class="rounded-circle btn btn-primary btn-sm plus-icon"
            [disabled]="tags?.length === 5"
            (click)="showAutocomplete = !showAutocomplete"
        >
            <svg xmlns="http://www.w3.org/2000/svg" id="mdi-tag-plus" viewBox="0 0 24 24" style="transform: scale(2.5);">
                <path fill="currentColor" d="M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4A2,2 0 0,0 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12A6,6 0 0,1 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M10,19H7V22H5V19H2V17H5V14H7V17H10V19Z" />
            </svg>
        </button>
    </ng-template>

    <div *ngIf="showAutocomplete" class="ml-3 d-flex autocomplete">
        <p-autoComplete
            dataKey="name"
            optionLabel="name"
            [minLength]="3"
            #autoComplete
            [inputStyle]="{ height: '28px' }"
            [multiple]="false"
            [showEmptyMessage]="true"
            [suggestions]="suggestions$ | async"
            [placeholder]="'common.type-to-search' | translate"
            [(ngModel)]="selectedTags"
            (onSelect)="onSelectTag($event)"
            (completeMethod)="onSearchTags($event)"
        >
            <ng-template let-value pTemplate="item">
                <div>{{ value.name }}</div>
            </ng-template>
        </p-autoComplete>
        <button
            pTooltip="{{ 'common.show-all' | translate }}"
            class="btn btn-primary search-icon"
            (click)="onSearchAll(autoComplete, $event)"
        >
            <fa-icon [icon]="['fas', 'search-plus']" />
        </button>
    </div>

    <div class="badge-container ml-3" *ngIf="tags?.length">
        <span
            *ngFor="let tag of tags; trackBy: trackByIndex"
            class="status-badge badge px-2 rounded-pill custom-tag"
            [ngStyle]="{ 'background-color': tag.attributes?.color, 'color': 'white' }"
            (click)="!tag.attributes?.is_system_tag ? editTagOp.toggle($event) : null"
        >
            {{ tag.attributes?.name }}
            <fa-icon [icon]="['far','edit']" class="ml-1 icon" *ngIf="!tag.attributes?.is_system_tag" />
            <fa-icon [icon]="['far','lock']" class="ml-1 icon" *ngIf="tag.attributes?.is_system_tag" />
            <p-overlayPanel #editTagOp>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item list-group-item-action">
                        <a (click)="onEditTag(tag)" [class.disable-link]="loadingCustomTags$ | async" href="javascript:void(0)">
                            <fa-icon [icon]="['far', 'edit']" size="lg" [fixedWidth]="true"></fa-icon>
                            {{ 'common.edit' | translate }}
                        </a>
                    </li>
                    <li class="list-group-item list-group-item-action">
                        <a (click)="onRemoveTag(tag.id); editTagOp.hide()" [class.disable-link]="loadingCustomTags$ | async" href="javascript:void(0)">
                            <fa-icon [icon]="['far', 'trash']" size="lg" [fixedWidth]="true"></fa-icon>
                            {{ 'common.remove' | translate }}
                        </a>
                    </li>
                </ul>
            </p-overlayPanel>
        </span>
    </div>
</div>

<p-dialog
    appendTo="body"
    [(visible)]="showModal"
    [showHeader]="false"
    [dismissableMask]="true"
    [modal]="true"
    [style]="{ width: '28rem', 'max-height': '300px' }">
    <form [formGroup]="tagForm" (ngSubmit)="onSubmit()" novalidate>
        <h5>{{ (isEditingMode ? 'portal.tags.edit-tag' : 'portal.tags.add-new-tag') | translate }}</h5>
        <div class="flex align-items-center gap-3 my-3">
            <label for="name" class="font-semibold w-6rem mr-2">{{ 'common.name' | translate }}</label>
            <input pInputText id="name" class="flex-auto" autocomplete="off" formControlName="name" maxlength="50" />
            <arv-validation-messages for="name">
                <arv-validation-message key="required">
                    <span class="text-danger">{{ 'common.validation.required' | translate : { field: 'common.name' | translate | lowercase } }}</span>
                </arv-validation-message>
            </arv-validation-messages>
        </div>
        <div class="flex align-items-center gap-3 mb-3">
            <label for="color" class="font-semibold w-6rem mr-2">{{ 'common.color' | translate }}</label>
            <p-colorPicker id="color" formControlName="color" appendTo="body" />
            <arv-validation-messages for="color">
                <arv-validation-message key="required">
                    <span class="text-danger">{{ 'common.validation.required' | translate : { field: 'common.color' | translate | lowercase } }}</span>
                </arv-validation-message>
            </arv-validation-messages>
        </div>
        <p class="form-text text-muted mb-2" *ngIf="isEditingMode"><fa-icon [icon]="['far', 'info-circle']" class="mr-2" />{{ 'portal.tags.edit-tag-hint' | translate }}</p>
        <div class="form-group border-top pt-3">
            <button class="btn btn-primary mr-2" type="submit" [disabled]="tagForm.invalid">
                <fa-icon [icon]="['far', 'spinner']" animation="spin-pulse" class="mr-2"
                         *ngIf="loadingCustomTags$ | async"></fa-icon>
                {{ 'common.save' | translate }}
            </button>
            <button class="btn btn-light" type="reset" [disabled]="tagForm.disabled" (click)="isEditingMode = false; showModal = false">{{ 'common.cancel' | translate }}</button>
        </div>
    </form>
</p-dialog>

